import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VersionsModule } from '@core/components/versions/versions.module';
import { FilesModule } from '@core/components/files/files.module';
import { CommonsModule } from '@core/components/commons/commons.module';
import { VersionFilesModule } from '@core/components/versions/version-files/version-files.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { PluginShareTransferSelectFilesSectionComponent } from './select-files/select-files.component';


@NgModule({
    imports: [
      CommonModule,
      HelperBoxModule,
      VersionsModule,
      FilesModule,
      CommonsModule,
      VersionFilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
      PluginShareTransferSelectFilesSectionComponent
    ],
    exports: [
      PluginShareTransferSelectFilesSectionComponent
    ],
    providers: [
    ]

})
export class ShareTransferSectionsModule { }
